import { apiRequest } from 'api/apiClient';

function extractSocialIds(response) {
  const socials = ['facebook', 'instagram', 'x', 'tiktok', 'pinterest'];
  const socialIds = {};

  // eslint-disable-next-line no-restricted-syntax
  for (const social of socials) {
    if (response[social]) {
      const match = response[social].match(/\/(?:@)?([^/]+)$/);
      if (match && match[1]) {
        const [, extractedId] = match;
        socialIds[social] = extractedId;
      } else {
        socialIds[social] = null;
      }
    } else {
      socialIds[social] = null;
    }
  }

  return socialIds;
}

const fetchStore = async () => {
  const response = await apiRequest('GET', '/v1/retailer-page/me', null);
  const socialIds = extractSocialIds(response);

  return {
    ...response,
    ...socialIds,
  };
};

const fetchPageModules = async () => {
  const response = await apiRequest('GET', '/v1/page-modules', null);
  return response;
};

const fetchRetailerPageAvailableLooks = async (uid) => {
  const response = await apiRequest('GET', `/v1/retailer-page/${uid}/available-looks`, null);
  return response;
};

const fetchRetailerPageAvailableBanners = async (uid) => {
  const response = await apiRequest('GET', `/v1/retailer-page/${uid}/available-banners`, null);
  return response;
};

const fetchRetailerPageAvailableVideos = async (uid) => {
  const response = await apiRequest('GET', `/v1/retailer-page/${uid}/available-videos`, null);
  return response;
};

const fetchRetailerPageAvailableParticipants = async (uid) => {
  const response = await apiRequest('GET', `/v1/retailer-page/${uid}/available-participants`, null);
  return response;
};

const fetchRetailerPageAvailableEvents = async (uid) => {
  const response = await apiRequest('GET', `/v1/retailer-page/${uid}/available-events`, null);
  return response;
};

const STORE_QUERIES = {
  FETCH_STORE: fetchStore,
  FETCH_PAGE_MODULES: fetchPageModules,
  FETCH_RETAILER_PAGE_AVAILABLE_LOOKS: fetchRetailerPageAvailableLooks,
  FETCH_RETAILER_PAGE_AVAILABLE_BANNERS: fetchRetailerPageAvailableBanners,
  FETCH_RETAILER_PAGE_AVAILABLE_VIDEOS: fetchRetailerPageAvailableVideos,
  FETCH_RETAILER_PAGE_AVAILABLE_PARTICIPANTS: fetchRetailerPageAvailableParticipants,
  FETCH_RETAILER_PAGE_AVAILABLE_EVENTS: fetchRetailerPageAvailableEvents,
};

export default STORE_QUERIES;
